import React from 'react';
import { Icon } from 'semantic-ui-react';
import clsx from 'clsx';

const ToastWrapper = ({
  children,
  className,
  color,
  icon,
}) => (
  <div className={clsx('aridhia-toast-wrapper', className)}>
    <Icon name={icon} color={color} />
    {children}
  </div>
);

export default ToastWrapper;
